import { motion } from "framer-motion";

const GROUPS = [
  {
    org: "8th Light",
    role: "Content Strategy (JumpSeat Client)",
    blurb:
      "Authored thought leadership on sports tech, biometrics, and fan engagement for enterprise software client.",
    pieces: [
      {
        title: "Walk-Out Technology Is Hitting Its Stride",
        kind: "Insight Article",
        href: "https://8thlight.com/insights/walk-out-technology-is-hitting-its-stride",
      },
      {
        title: "Hand, Meet Prime Time: Biometrics Drive Fan Experiences",
        kind: "Insight Article",
        href: "https://8thlight.com/insights/hand-meet-prime-time-biometrics-drive-fan-experiences",
      },
      {
        title:
          "From VHS to Interactive Streams: Customization at Scale with NFL Sunday Ticket on YouTube",
        kind: "Insight Article",
        href: "https://8thlight.com/insights/from-vhs-to-interactive-streams-customization-at-scale-with-the-nfl-sunday-ticket-on-youtube-2",
      },
      {
        title: "WWE and Netflix Go Live, Loud, and Hopefully Unbreakable",
        kind: "Insight Article",
        href: "https://8thlight.com/insights/wwe-and-netflix-go-live-loud-and-hopefully-unbreakable",
      },
    ],
  },
  {
    org: "Muros",
    role: "Senior Marketing Manager",
    blurb:
      "Thought leadership on experiential marketing, OOH advertising, and art-driven brand engagement.",
    pieces: [
      {
        title:
          "Sports, Art, and Engagement: How Muros Is Helping Professional Sport Teams Create Lasting Connections",
        kind: "Blog Post",
        href: "https://www.muros.com/sports-art-and-engagement-how-muros-is-helping-professional-sport-teams-create-lasting-connections/",
      },
      {
        title: "The Importance of Art in the Workplace",
        kind: "Blog Post",
        href: "https://www.muros.com/the-importance-of-art-in-the-workplace/",
      },
      {
        title:
          "Engagement & Exposure: 3 Reasons Why Experiential Marketing Beats Billboards Every Time",
        kind: "Blog Post",
        href: "https://www.muros.com/engagement-and-exposure-3-reasons-why-experiential-marketing-beats-billboards-every-time/",
      },
      {
        title: "Behind the Brush with Jappy Agoncillo",
        kind: "Artist Interview",
        href: "https://www.muros.com/behind-the-brush-with-jappy-agoncillo/",
      },
      {
        title: "How Murals Are Becoming a New Face of Out-of-Home Advertising",
        kind: "Blog Post",
        href: "https://www.muros.com/how-murals-are-becoming-a-new-face-of-out-of-home-advertising/",
      },
      {
        title: "Building the Brand: The Important Role of Art and Culture",
        kind: "Blog Post",
        href: "https://www.muros.com/building-the-brand-the-important-role-of-art-and-culture/",
      },
      {
        title:
          "Muros Wraps a Successful 2023 with Inc. 5000 Honor & a Growing Portfolio of Impactful Campaigns",
        kind: "Press Release — PR Newswire",
        href: "https://www.prnewswire.com/news-releases/muros-wraps-a-successful-2023-with-inc-5000-honor-and-a-growing-portfolio-of-impactful-campaigns-302010247.html",
      },
    ],
  },
  {
    org: "Revolution Cannabis",
    role: "Marketing Manager",
    blurb:
      "Educational content and thought leadership for the #1 cannabis brand, driving industry conversation.",
    pieces: [
      {
        title: "The Impact of the 2018 Farm Bill",
        kind: "Educational Article",
        href: "https://www.revcanna.com/learn/the-impact-of-the-2018-farm-bill/",
      },
      {
        title: "Celebrating Freedom, Demanding Change",
        kind: "Opinion Piece",
        href: "https://www.revolutionenterprises.org/celebrating-freedom-demanding-change/",
      },
      {
        title: "The Advocate Weekly: Cannabis News",
        kind: "Newsletter",
        href: "https://www.revolutionenterprises.org/the-advocate-weekly-cannabis-news-120/",
      },
      {
        title: "Cannabis Cultivator Releases New Podcast Series",
        kind: "Press Release — PR Newswire",
        href: "https://www.prnewswire.com/news-releases/cannabis-cultivator-releases-new-podcast-series-300749454.html",
      },
    ],
  },
];

const STATS = [
  { n: "100+", label: "Published Articles" },
  { n: "10+", label: "Companies" },
  { n: "20+", label: "Press Releases" },
  { n: "6+", label: "Industries" },
];

export default function Writing() {
  return (
    <section
      id="writing"
      data-testid="writing-section"
      className="px-4 md:px-8 lg:px-12 py-20 md:py-28 bg-[#E8E4DB] hard-border-t hard-border-b"
    >
      <div className="grid grid-cols-12 gap-6 mb-10 md:mb-14">
        <div className="col-span-12 md:col-span-8">
          <div className="section-label mb-3 text-[#4A4A4A]">§ 06 — Writing &amp; Press</div>
          <h2 className="font-anton uppercase text-6xl md:text-8xl lg:text-9xl leading-[0.88]">
            Words
            <span className="font-cormorant italic text-[#D83127] font-semibold"> that </span>
            move markets.
          </h2>
        </div>
        <p className="col-span-12 md:col-span-4 font-cormorant italic text-xl md:text-2xl self-end text-[#1a1a1a]">
          Thought leadership, client ghostwriting, and content that earned its keep —
          across sports tech, experiential, and cannabis.
        </p>
      </div>

      {/* stat ribbon */}
      <div className="hard-border grid grid-cols-2 md:grid-cols-4 mb-12 md:mb-16 bg-[#F2EFE9]">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            className={`p-6 md:p-8 ${i < STATS.length - 1 ? "border-b md:border-b-0 md:border-r border-[#111111]" : ""} ${
              i < 2 ? "border-r border-[#111111] md:border-r" : ""
            }`}
            data-testid={`writing-stat-${i}`}
          >
            <div className="font-anton text-5xl md:text-7xl leading-none">{s.n}</div>
            <div className="font-mono-s text-[10px] md:text-xs tracking-[0.25em] uppercase mt-2 text-[#4A4A4A]">
              {s.label}
            </div>
          </div>
        ))}
      </div>

      {/* group list */}
      <div className="space-y-12 md:space-y-16">
        {GROUPS.map((g, gi) => (
          <motion.div
            key={g.org}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="grid grid-cols-12 gap-6 hard-border-t pt-8 md:pt-10"
            data-testid={`writing-group-${gi}`}
          >
            <div className="col-span-12 md:col-span-4">
              <div className="font-mono-s text-[10px] tracking-[0.3em] uppercase text-[#4A4A4A] mb-2">
                Portfolio / {String(gi + 1).padStart(2, "0")}
              </div>
              <h3 className="font-anton uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
                {g.org}
              </h3>
              <div className="font-cormorant italic text-lg md:text-xl mt-2 text-[#1a1a1a]">
                {g.role}
              </div>
              <p className="font-work text-base md:text-lg mt-4 leading-relaxed max-w-sm">
                {g.blurb}
              </p>
              <div className="font-mono-s text-[10px] tracking-[0.2em] uppercase mt-4 text-[#D83127]">
                ▸ {g.pieces.length} piece{g.pieces.length > 1 ? "s" : ""}
              </div>
            </div>

            <ul className="col-span-12 md:col-span-8">
              {g.pieces.map((p, pi) => (
                <li key={p.href}>
                  <a
                    href={p.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`writing-piece-${gi}-${pi}`}
                    className="group flex flex-col md:flex-row md:items-baseline gap-2 md:gap-6 py-4 md:py-5 border-t border-[#111111]/30 hover:bg-[#F2EFE9] transition-colors"
                  >
                    <span className="font-mono-s text-[10px] tracking-[0.3em] uppercase text-[#4A4A4A] md:w-10 shrink-0">
                      {String(pi + 1).padStart(2, "0")}
                    </span>
                    <span className="font-anton uppercase text-2xl md:text-3xl leading-tight flex-1 group-hover:text-[#D83127] transition-colors">
                      {p.title}
                    </span>
                    <span className="font-mono-s text-[10px] md:text-xs tracking-[0.2em] uppercase text-[#1a1a1a] shrink-0">
                      {p.kind} →
                    </span>
                  </a>
                </li>
              ))}
              <div className="border-t border-[#111111]/30" />
            </ul>
          </motion.div>
        ))}
      </div>

      <div className="mt-16 hard-border p-6 md:p-10 bg-[#111111] text-[#F2EFE9] flex flex-col md:flex-row md:items-end gap-6 justify-between">
        <div>
          <div className="font-mono-s text-[10px] tracking-[0.3em] uppercase text-[#F2EFE9]/60 mb-2">
            Strategic Content Partnership
          </div>
          <div className="font-anton uppercase text-4xl md:text-5xl leading-tight">
            Available for thought leadership,
            <br />
            ghostwriting, and content partnerships.
          </div>
        </div>
        <a href="#contact" className="btn-offset inverse shrink-0" data-testid="writing-collaborate-cta">
          Start a Conversation →
        </a>
      </div>
    </section>
  );
}
